if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
document.addEventListener('click', (e) => {
  const lightbox = document.getElementById('new-mobile-lightbox');
  if (!lightbox || !lightbox.classList.contains('active')) return;

  const img = e.target.closest('#new-mobile-lightbox img');
  if (!img) return;

  lightbox.classList.toggle('zoomed');

  // 🔑 BUG FIX: zoom olunca en üste al
  if (lightbox.classList.contains('zoomed')) {
    const wrapper = lightbox.querySelector('.new-lightbox-image-wrapper');
    if (wrapper) wrapper.scrollTop = 0;
  }
});
